// Feature text rows (title = bis inkl. erstem Wort vor Doppelpunkt, content = Rest, icon = dummy)
export const FEATURES_TOP_ROW = [
  {
    title: "Vielseitig",
    content: "Für den ÖGD entwickelt, und darüber hinaus einsetzbar. GA-Lotse kann von öffentlichen Institutionen für unterschiedliche Verwaltungsprozesse genutzt werden.",
    icon: "all-in-one-app",
  },
    {
    title: "Sicher",
    content: "Hohe Ausfallsicherheit durch Mehrfachredundanz und Datensicherheit auf maximalem Niveau durch „Zero Trust“.",
    icon: "sichere-cloud",
  },
  {
    title: "Einfach nutzbar",
    content: "Dezentral und ohne zusätzliche Installation über aktuelle Webbrowser auf verschiedenen Endgeräten nutzbar.",
    icon: "leicht-dank-cloud",
  },
  {
    title: "Offlinefähig",
    content: "Auch ohne Internet nutzbar – im Offlinemodus mit automatischer Datensynchronisierung.",
    icon: "offline-modus",
  },
  {
    title: "Desktop & Mobile",
    content: "Ob PC-Monitor, Laptop, Tablet oder Smartphone – die Darstellung passt sich Ihrem Gerät an.",
    icon: "mobile-und-pc",
  }
];

export const FEATURES_MIDDLE_ROW = [
  {
    title: "Skalierbar",
    content: "Flexible Softwarelösung, anpassbar an den realen Bedarf aller öffentlichen Institutionen.",
    icon: "skalierbare-app",
  },
  {
    title: "Grundmodul",
    content: "Wichtige Basisfunktionen wie interne Prozesse mit Kontakten, Inventar, Ressourcen, Chat, Statistik und integriertem Online-Portal für Bürger:innen.",
    icon: "grundmodul_solid",
  },
  {
    title: "Online-Portal für Bürger:innen",
    content: "Selfservice-Portal für Bürger:innen mit integrierter Fachmodulanbindung.",
    icon: "webportal",
  },
];

export const FEATURES_BOTTOM_ROW = [
  {
    title: "Open Source",
    content: "Offene Software stärkt die Unabhängigkeit und digitale Souveränität der öffentlichen Verwaltung und ermöglicht eine bedarfsgerechte Anpassung an individuelle Anforderungen.",
    icon: "open-source",
  },
  {
    title: "LMS",
    content: "Schulungsmaterialien, Anleitungen und Lernvideos unterstützen beim Einstieg und bei der Nutzung der Software.",
    icon: "fortbildung",
  },
  {
    title: "Prozessmanagement",
    content: "Modulare Abbildung und Steuerung unterschiedlicher Verwaltungsprozesse - flexibel anpassbar an individuelle Abläufe und Anforderungen.",
    icon: "prozessschritte",
  },
  {
    title: "Weiterentwicklung",
    content: "Die Software wird kontinuierlich weiterentwickelt. Erfahrungen und Anforderungen aus der Praxis fließen in die Weiterentwicklung bestehender Funktionen und die Entwicklung neuer Module ein.",
    icon: "weiterentwicklung",
  },
];

